import { Divider, Flex, FlexProps } from "@chakra-ui/react";
import { ReactNode } from "react";

import { colors } from "src/colors";
import getNameProp from "src/utils/getNameProp";

type Props = FlexProps & {
  children: ReactNode;
};

export const OrderSummaryItemWrapper = ({ children, ...props }: Props) => {
  return (
    <Flex
      direction="column"
      borderRadius="8px"
      width="100%"
      {...getNameProp("order-item-order-summary")}
      {...props}
    >
      {children}

      <Divider m="32px 0px 12px 0px" borderColor={colors.grey[900]} />
    </Flex>
  );
};
